import { filtersHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';
import { requestLogModel } from '@/models/api/requestLog.model';

export const communicationLogModel = (data) => ({
    uuid: data.uuid,
    method: data.method,
    purpose: data.purpose,
    from: data.from,
    to: data.to,
    cc: data.cc,
    bcc: data.bcc,
    payload: data.payload,
    content: data.content,
    subject: data.subject,
    isUsed: data.is_used,
    isActive: data.is_active,
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    createdBy: data.created_by,
    updatedAt: filtersHelper.getDateFormat(data.updated_at),
    updatedBy: data.updated_by,
    deletedAt: filtersHelper.getDateFormat(data.deleted_at),
    deletedBy: data.deleted_by,
    user: data.user ? userModel(data.user) : null,
    requestLog: data.request_log ? requestLogModel(data.request_log) : null,
});